import React from 'react';
import Typography from '@material-ui/core/Typography';
import { styled } from '@material-ui/core/styles';

export const StyledGrid = styled('div')(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: '280px 280px',
  gridRowGap: '47px',

  [theme.breakpoints.up('md')]: {
    gridTemplateColumns: '298px 298px',
  },
}));

const StyledAppInfo = styled('div')({
  display: 'grid',
  gridGap: '11px',
});

export const AppInfo: React.FC<{ label: string; value?: string | null }> = ({ label, value }) => (
  <StyledAppInfo>
    <Typography variant="body2">{label}</Typography>
    <Typography>{value}</Typography>
  </StyledAppInfo>
);
